import { AXIOSMETHOD } from "constants/enum_axios_methods";
import { ELECTRONICRESOURCE } from "constants/enum_electronic_resource";
import { IAchivementsParams } from "interfaces/interface_achivements";
import { IRESEARCHPlan } from "interfaces/interface_researchPlanTyp";
import apiBuilder from "./apiBuilder";

const SUBBASEURL = "/developmentResearchUser";

type TPaginationParams = { page: number; pageSize?: number; locale?: string };
type TComment = { Name: string; Phone: string; Description: string };
type TElectronicResource = {
  page: number;
  pageSize?: number;
  Type: ELECTRONICRESOURCE;
  locale?: string;
};
type TCovidParams = { page: number; pageSize: number; Type: 0 | 1; locale?: string; Year: string };
type INewsParams = {
  InnovationNews: boolean;
  page: number;
  pageSize: number;
  Search?: string;
  Sort: 0 | 1;
  locale?: string;
};

//--------------------------------------------------------------------------------------------------

export const getDLanguages = (locale?: string) => {
  let url = `${SUBBASEURL}/language`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getDSetting = (locale?: string, Type?: "site" | "dr") => {
  let url = `${SUBBASEURL}/setting`;

  let params = { Type };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getDMainPage = (locale?: string) => {
  let url = `${SUBBASEURL}/mainPage`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getDUnitIntroduction = (locale?: string) => {
  let url = `${SUBBASEURL}/unitIntroduction`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const addDUnitIntroduction = (data: IRESEARCHPlan) => {
  let url = `${SUBBASEURL}/researchProject`;
  let temp = data;

  if (typeof data.PlanType === "object") temp.PlanType = data.PlanType?.name;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.POST).setBody(temp).call();
};

//--------------------------------------------------------------------------------------------------

export const getDInvention = ({ Year, page, pageSize, locale }: IAchivementsParams) => {
  let url = `${SUBBASEURL}/invention`;

  let params = { Year, page, pageSize };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

export const getDInventionYears = (locale?: string) => {
  let url = `${SUBBASEURL}/invention/year`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

export const getDResearchWorkShop = ({ Year, page, pageSize, locale }: IAchivementsParams) => {
  let url = `${SUBBASEURL}/researchWorkshop`;

  let params = { Year, page, pageSize };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

export const getDResearchWorkShopYears = (locale?: string) => {
  let url = `${SUBBASEURL}/researchWorkshop/year`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

export const getDResearchInformationBank = ({
  Year,
  page,
  pageSize,
  locale,
}: IAchivementsParams) => {
  let url = `${SUBBASEURL}/researchInformationBank`;

  let params = { Year, page, pageSize };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

export const getDResearchInformationBankYears = (locale?: string) => {
  let url = `${SUBBASEURL}/researchInformationBank/year`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

export const getDPrintedArticleSummary = ({ Year, page, pageSize, locale }: IAchivementsParams) => {
  let url = `${SUBBASEURL}/printedArticleSummary`;

  let params = { Year, page, pageSize };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

export const getDPrintedArticleSummaryYears = (locale?: string) => {
  let url = `${SUBBASEURL}/printedArticleSummary/year`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

export const getDPrintedArticle = ({ Year, page, pageSize, locale }: IAchivementsParams) => {
  let url = `${SUBBASEURL}/printedArticle`;

  let params = { Year, page, pageSize };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

export const getDPrintedArticleYears = (locale?: string) => {
  let url = `${SUBBASEURL}/printedArticle/year`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

export const getDResearchProject = ({ Year, page, pageSize, locale }: IAchivementsParams) => {
  let url = `${SUBBASEURL}/researchProject`;

  let params = { Year, page, pageSize };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

export const getDResearchProjectYears = (locale?: string) => {
  let url = `${SUBBASEURL}/researchProject/year`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

export const getDThesis = ({ Year, page, pageSize, locale }: IAchivementsParams) => {
  let url = `${SUBBASEURL}/thesis`;

  let params = { Year, page, pageSize };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

export const getDThesisYears = (locale?: string) => {
  let url = `${SUBBASEURL}/thesis/year`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getDUnitSupervisor = (locale?: string) => {
  let url = `${SUBBASEURL}/unitMember/unitSupervisor`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

export const getDDeputySuperintendent = (locale?: string) => {
  let url = `${SUBBASEURL}/unitMember/deputySuperintendent`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

export const getDClinicalResearchDirector = (locale?: string) => {
  let url = `${SUBBASEURL}/unitMember/clinicalResearchDirector`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

export const getDClinicalResearchDevelopmentDirector = (locale?: string) => {
  let url = `${SUBBASEURL}/unitMember/clinicalResearchDevelopmentDirector`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

export const getDClinicalResearchDevelopmentSecretary = (locale?: string) => {
  let url = `${SUBBASEURL}/unitMember/clinicalResearchDevelopmentSecretary`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

export const getDUnitCouncil = ({ page, pageSize, locale }: IAchivementsParams) => {
  let url = `${SUBBASEURL}/unitMember/unitCouncil`;

  let params = { page, pageSize };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

export const getDUnitConsultant = ({ page, pageSize, locale }: IAchivementsParams) => {
  let url = `${SUBBASEURL}/unitMember/unitConsultant`;

  let params = { page, pageSize };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

export const getDUnitExpert = ({ page, pageSize, locale }: IAchivementsParams) => {
  let url = `${SUBBASEURL}/unitMember/unitExpert `;

  let params = { page, pageSize };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getDGoalsAndPlans = (locale?: string) => {
  let url = `${SUBBASEURL}/goalsAndPlans`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getDContactUs = (locale?: string) => {
  let url = `${SUBBASEURL}/unitCommunication`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

export const addDComment = (data: TComment) => {
  let url = `${SUBBASEURL}/comment`;
  let temp = data;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.POST).setBody(temp).call();
};

//--------------------------------------------------------------------------------------------------

export const getDElectronicResources = ({
  page,
  pageSize = 10,
  Type,
  locale,
}: TElectronicResource) => {
  let url = `${SUBBASEURL}/electronicResource`;

  let params = { page, pageSize, Type };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getDClinicalEducationalContent = ({ page, pageSize, locale }: TPaginationParams) => {
  let url = `${SUBBASEURL}/clinicalEducationalContent`;

  let params = { page, pageSize };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

export const getDClinicalEducationalContentOne = (id: number, locale?: string) => {
  let url = `${SUBBASEURL}/clinicalEducationalContent/${id}`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getDCovid19 = ({ page, pageSize, Type, locale, Year }: TCovidParams) => {
  let url = `${SUBBASEURL}/covid19`;

  let params = { page, pageSize, Type, Year };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

export const getDCovid19One = (id: number, locale?: string) => {
  let url = `${SUBBASEURL}/covid19/${id}`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getDNews = ({ InnovationNews, page, pageSize, Search, Sort, locale }: INewsParams) => {
  let url = `${SUBBASEURL}/news`;

  let params = { InnovationNews, page, pageSize, Search, Sort };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

export const getDNewsOne = (id: number, locale?: string) => {
  let url = `${SUBBASEURL}/news/${id}`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getDResearchConsultancy = ({ page, pageSize, locale }: TPaginationParams) => {
  let url = `${SUBBASEURL}/researchConsultancy`;

  let params = { page, pageSize };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getDResearchCouncilMeeting = ({
  Year,
  page,
  pageSize,
  locale,
}: IAchivementsParams) => {
  let url = `${SUBBASEURL}/researchCouncilMeeting`;

  let params = { Year, page, pageSize };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

export const getDResearchCouncilMeetingYears = (locale?: string) => {
  let url = `${SUBBASEURL}/researchCouncilMeeting/year`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getDResearchCouncilMeetingsCalendar = ({
  Year,
  page,
  pageSize,
  locale,
}: IAchivementsParams) => {
  let url = `${SUBBASEURL}/researchCouncilMeetingsCalendar`;

  let params = { Year, page, pageSize };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

export const getDResearchCouncilMeetingsCalendarYears = (locale?: string) => {
  let url = `${SUBBASEURL}/researchCouncilMeetingsCalendar/year`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getDThanking = (locale?: string) => {
  let url = `${SUBBASEURL}/thanking`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getDRule = (locale?: string) => {
  let url = `${SUBBASEURL}/rule`;

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).call(locale);
};

//--------------------------------------------------------------------------------------------------

export const getDTeachingResearch = ({ page, pageSize = 10, locale }: TPaginationParams) => {
  let url = `${SUBBASEURL}/teachingResearch`;
  let params = { page, pageSize };
  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

//-------------------------------------------------------------------------

export const getDUnitRegulation = ({ page, pageSize = 10, locale }: TPaginationParams) => {
  let url = `${SUBBASEURL}/unitRegulation`;

  let params = { page, pageSize };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};

//-------------------------------------------------------------------------

export const getDInvalidArticles = ({ page, pageSize = 10, locale }: TPaginationParams) => {
  let url = `${SUBBASEURL}/invalidArticles`;

  let params = { page, pageSize };

  return apiBuilder.setUrl(url).setMethod(AXIOSMETHOD.GET).setParams(params).call(locale);
};
